import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils/cn";

export type SkeletonProps = HTMLAttributes<HTMLDivElement>;

/**
 * Skeleton loader per lista dhe detaje pa perdorur spinner.
 */
export const Skeleton = ({ className, ...props }: SkeletonProps): JSX.Element => (
  <div className={cn("animate-pulse rounded-md bg-muted", className)} {...props} />
);
